<template @click="cancelHandler">
  <v-dialog v-model="dialog" persistent max-width="400px">
    <v-card>
      <v-card-text class="dialog-message pa-5 pt-7 subtitle-1">
        <span v-html="message" />
      </v-card-text>
      <v-card-actions class="px-7 py-5">
        <v-row v-if="!confirmOnly" justify="space-between">
          <v-btn
            @click="cancelHandler"
            color="primary"
            v-text="$t('CANCEL')"
            :min-width="100"
            v-if="!confirmOnly"
          />
          <v-btn @click="confirmHandler" color="primary" v-text="$t('YES')" :min-width="100" />
        </v-row>
        <v-row v-if="confirmOnly" justify="end">
          <v-btn @click="confirmHandler" color="primary" v-text="$t('OK')" :min-width="100" />
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'TheDialog',
    data() {
      return {
        dialog: true,
      };
    },
    computed: {
      ...mapState('dialog', ['message', 'confirmOnly']),
    },
    mounted() {
      window.addEventListener('keydown', this.closeHandler);
    },
    beforeDestroy() {
      window.removeEventListener('keydown', this.closeHandler);
    },
    methods: {
      ...mapActions('dialog', ['confirmDialog', 'cancelDialog']),

      confirmHandler() {
        this.confirmDialog();
      },
      cancelHandler() {
        this.cancelDialog();
      },
      closeHandler(e) {
        if (e.key === 'Escape') {
          this.cancelDialog();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .dialog-message {
    text-align: center;
  }
</style>
